var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareWhatsapp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.532,
    y1: 1.084,
    x2: 0.5,
    y2: 0.331,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06b824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bf877"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -709)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    transform: "translate(16 709)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20.933l1.462-5.2a10.421,10.421,0,1,1,3.894,3.82ZM7.525,5.582l-.677-.037a.817.817,0,0,0-.581.2A3.084,3.084,0,0,0,5.253,7.3a4.718,4.718,0,0,0,1.092,3.7A10.976,10.976,0,0,0,12.262,15.3,2.879,2.879,0,0,0,14.7,15a2.188,2.188,0,0,0,.95-1.388l.108-.505a.351.351,0,0,0-.2-.392L13.28,11.658a.351.351,0,0,0-.424.1l-.9,1.165a.257.257,0,0,1-.289.087,7.038,7.038,0,0,1-3.8-3.26.259.259,0,0,1,.033-.29l.858-.994A.352.352,0,0,0,8.814,8.1L7.828,5.794a.352.352,0,0,0-.3-.213M5.631,17.653l.319.195a8.671,8.671,0,1,0-2.786-2.728l.215.336-.842,3Z",
    transform: "translate(25.846 718.534)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhatsapp);
export default __webpack_public_path__ + "static/media/shareWhatsapp.24d6283b0b76686c31a8cb604df45ddd.svg";
export { ForwardRef as ReactComponent };